<template>
  <div
    class="modal fade"
    id="modal-form-viaje-guia-import"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content shadow">
        <div class="modal-header bg-geogo-top-left pt-2 pb-2">
          <h5 class="modal-title text-white">
            <i class="fas fa-file-upload mr-2"></i>
            Importar Viajes
          </h5>
          <button
            type="button"
            class="close text-white"
            data-dismiss="modal"
            aria-label="Close"
            id="close-modal"
            ref="closeModal1"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Descargar Plantilla -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card border-info">
                <div class="card-header bg-info text-white">
                  <h6 class="mb-0">
                    <i class="fas fa-download mr-2"></i>
                    Descargar Plantilla
                  </h6>
                </div>
                <div class="card-body">
                  <p class="text-muted mb-3">
                    Descarga el archivo de plantilla para importar los viajes
                    correctamente.
                  </p>
                  <button
                    type="button"
                    class="btn btn-outline-success btn-sm"
                    @click="descargarPlantilla"
                  >
                    <i class="fas fa-file-excel mr-1"></i>
                    Descargar Plantilla Excel
                  </button>
                  <div class="mt-3">
                    <div
                      class="upload-area"
                      :class="{
                        'drag-over': isDragOver,
                        'has-file': selectedFile,
                      }"
                      @dragover.prevent="handleDragOver"
                      @dragleave.prevent="handleDragLeave"
                      @drop.prevent="handleDrop"
                      @click="triggerFileInput"
                    >
                      <div v-if="!selectedFile" class="upload-placeholder">
                        <i
                          class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"
                        ></i>
                        <h5 class="text-muted">Arrastra tu archivo aquí</h5>
                        <p class="text-muted">o haz clic para seleccionar</p>
                        <small class="text-muted">
                          Formatos soportados: .xlsx, .xls, .csv
                        </small>
                      </div>
                      <div v-else class="file-selected">
                        <i
                          class="fas fa-file-excel fa-3x text-success mb-3"
                        ></i>
                        <h6 class="text-success">{{ selectedFile.name }}</h6>
                        <p class="text-muted mb-2">
                          Tamaño: {{ formatFileSize(selectedFile.size) }}
                        </p>
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-sm"
                          @click.stop="removeFile"
                        >
                          <i class="fas fa-times mr-1"></i>
                          Eliminar
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Hidden File Input -->
                  <input
                    ref="fileInput"
                    type="file"
                    class="d-none"
                    accept=".xlsx,.xls,.csv"
                    @change="handleFileSelect"
                  />

                  <!-- Progress Bar -->
                  <div v-if="uploading" class="mt-3">
                    <div class="progress">
                      <div
                        class="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        :style="{ width: uploadProgress + '%' }"
                      >
                        {{ uploadProgress }}%
                      </div>
                    </div>
                    <small class="text-muted mt-1 d-block">
                      Subiendo archivo...
                    </small>
                  </div>

                  <!-- Success/Error Messages -->
                  <div v-if="uploadMessage" class="mt-3">
                    <div
                      class="alert"
                      :class="uploadSuccess ? 'alert-success' : 'alert-danger'"
                    >
                      <i
                        class="fas mr-2"
                        :class="
                          uploadSuccess
                            ? 'fa-check-circle'
                            : 'fa-exclamation-triangle'
                        "
                      ></i>
                      {{ uploadMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            data-dismiss="modal"
          >
            <i class="fas fa-times mr-1"></i>
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            :disabled="!selectedFile || uploading"
            @click="subirArchivo"
          >
            <i class="fas fa-upload mr-1"></i>
            {{ uploading ? "Subiendo..." : "Subir Archivo" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "ViajeGuiaImport",
  data() {
    return {
      selectedFile: null,
      isDragOver: false,
      uploading: false,
      uploadProgress: 0,
      uploadMessage: "",
      uploadSuccess: false,
    };
  },
  methods: {
    descargarPlantilla() {
      axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/exportViajeMasivo",
      })
        .then((response) => {
          let data = response.data;
          location.href = data.url;
          this.$swal({
            title: "Exito",
            text: data.message,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error inesperado " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },

    // Manejar drag & drop
    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
    },

    handleDragLeave(event) {
      event.preventDefault();
      this.isDragOver = false;
    },

    handleDrop(event) {
      event.preventDefault();
      this.isDragOver = false;

      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.validateAndSetFile(files[0]);
      }
    },

    // Trigger file input
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    // Manejar selección de archivo
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.validateAndSetFile(file);
      }
    },

    // Validar y establecer archivo
    validateAndSetFile(file) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel", // .xls
        "text/csv", // .csv
      ];

      const allowedExtensions = [".xlsx", ".xls", ".csv"];
      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));

      if (
        !allowedTypes.includes(file.type) &&
        !allowedExtensions.includes(fileExtension)
      ) {
        this.$swal({
          icon: "error",
          title: "Formato no válido",
          text: "Solo se permiten archivos Excel (.xlsx, .xls) o CSV (.csv)",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      // Validar tamaño (máximo 10MB)
      /*  const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$swal({
          icon: "error",
          title: "Archivo muy grande",
          text: "El archivo no puede ser mayor a 10MB",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } */

      this.selectedFile = file;
      this.uploadMessage = "";
      this.uploadSuccess = false;
    },

    // Remover archivo seleccionado
    removeFile() {
      this.selectedFile = null;
      this.$refs.fileInput.value = "";
      this.uploadMessage = "";
      this.uploadSuccess = false;
    },

    // Formatear tamaño de archivo
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    // Subir archivo
    async subirArchivo() {
      if (!this.selectedFile) {
        this.$swal({
          icon: "error",
          title: "No hay archivo seleccionado",
          text: "Por favor selecciona un archivo para subir",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      this.uploading = true;
      this.uploadProgress = 0;
      this.uploadMessage = "";

      let formData = new FormData();
      formData.append("file", this.selectedFile);

      try {
        const response = await axios.post(
          "/api/hidrocarburos/viajes/importViajeMasivo",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          }
        );

        this.uploadSuccess = true;
        console.log(response.data);        
        let result_content = response.data.errores.length
          ? `<div>
                <p class="text-danger">
                  <strong>Los viajes no se cargaron.</strong>
                </p>
              </div>`
          : `<div>
                <p class="text-success">
                  <strong>Los viajes se cargaron exitosamente.</strong>
                </p>
              </div>`;

        if (response.data.errores.length) {
          result_content += `<h4>Errores encontrados.</h4>`;
          response.data.errores.forEach(
            (err) => (result_content += `<div><small>${err}</small></div>`)
          );
        }

        this.$swal({
          title: "Resultado de la carga.",
          html: result_content,
          icon: response.data.errores.length ? "error" : "success",          
          backdrop: `rgba(0,0,123,0.4) left top no-repeat`,
        });

        // Cerrar modal después de un tiempo
        setTimeout(() => {
          this.$refs.closeModal1.click();
          this.resetForm();
          // Emitir evento para refrescar la lista de viajes
          this.$emit("archivo-subido");
        }, 2000);
      } catch (error) {
        this.uploadSuccess = false;
        this.uploadMessage = "Error al subir el archivo";

        this.$swal({
          icon: "error",
          title: "Error al subir archivo",
          text: this.uploadMessage,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
        });
      } finally {
        this.uploading = false;
      }
    },

    // Resetear formulario
    resetForm() {
      this.selectedFile = null;
      this.uploading = false;
      this.uploadProgress = 0;
      this.uploadMessage = "";
      this.uploadSuccess = false;
      this.isDragOver = false;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
  },

  // Limpiar al cerrar modal
  mounted() {
    const modalElement = document.getElementById(
      "modal-form-viaje-guia-import"
    );
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  },
};
</script>

<style scoped>
.upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area:hover {
  border-color: #007bff;
  background-color: #e3f2fd;
}

.upload-area.drag-over {
  border-color: #007bff;
  background-color: #e3f2fd;
  transform: scale(1.02);
}

.upload-area.has-file {
  border-color: #28a745;
  background-color: #d4edda;
}

.upload-placeholder {
  width: 100%;
}

.file-selected {
  width: 100%;
}

.progress {
  height: 20px;
}

.progress-bar {
  font-size: 12px;
  line-height: 20px;
}

.card {
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.modal-content {
  border: none;
  border-radius: 10px;
}

.modal-header {
  border-radius: 10px 10px 0 0;
}

.modal-footer {
  border-radius: 0 0 10px 10px;
}

.btn {
  border-radius: 6px;
  font-weight: 500;
}

.alert {
  border-radius: 6px;
  border: none;
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.upload-area {
  animation: fadeIn 0.3s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .upload-area {
    min-height: 150px;
    padding: 1rem;
  }

  .upload-placeholder h5 {
    font-size: 1.1rem;
  }

  .upload-placeholder p {
    font-size: 0.9rem;
  }
}
</style>
